import Vue from 'vue'
import Router from 'vue-router'

import Home from './../components/Home.vue'
import Login from './../components/auth/Login.vue'
import Logout from './../components/auth/Logout.vue'
import AdminDashboard from './../components/admin/Dashboard.vue'
import AdminLayout from './../components/admin/Layout.vue'
import My from './../components/my/My.vue'
import ChangePassword from './../components/my/ChangePassword.vue'

import templates from './templates'
import users from './users'
import accounts from './accounts'
import emailGroups from './emailGroups'
import emails from './emails'
import messages from './messages'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: Home,
    name: 'home'
  },
  {
    path: '/login',
    component: Login,
    name: 'login'
  },
  {
    path: '/logout',
    component: Logout,
    name: 'logout'
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      {
        path: '',
        component: AdminDashboard,
        name: 'admin.home'
      },
      {
        path: 'my',
        name: 'admin.my',
        component: My
      },
      {
        path: 'change-password',
        name: 'admin.change-password',
        component: ChangePassword
      },

      users,
      templates,
      accounts,
      emailGroups,
      emails,
      messages
    ]
  }
]

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js